export class Zona {
    codigoZona: number;
    nombre: string;
}